module.exports = __webpack_public_path__ + "static/media/GMA-S2100SK-7AER_OR13_beautyshot1.9b15475f.jpg";